<mat-toolbar>
    <div class="footer-container">
        <div class="footer-left-buttons-container"><a (click)="openImportUsesPage()" *ngIf="showImportButton"
                class="download-link">{{ getImportButtonLabel() }}</a>
        </div>
        <div class="footer-buttons-container">
            <app-zc-xlsx-export-button *ngIf="getCanExportToXSLX$ | async"
                style="margin-right: 10px;"></app-zc-xlsx-export-button>
            <zc-validation-icon class="zc-validation-icon green" style="margin-right: 10px;"></zc-validation-icon>
            <button mat-raised-button color="accent" (click)="publishDraft()" [disabled]="!canPublish"
                *ngIf="canShowPublishButton$ | async">Publish</button>
            <span class="pr05 to-right">{{statusText}}</span>
            <button mat-raised-button color="primary"
                [disabled]="!isZCValidWithoutRequiredFields || !isZoningCodeChanged"
                (click)="saveChangedData()">Save</button>
            <button mat-raised-button (click)="cancelChanges()" [disabled]="!isZoningCodeChanged">Cancel</button>
            <button *ngIf="showValidateButton" mat-raised-button (click)="validateZC()">Validate</button>
        </div>
    </div>
</mat-toolbar>
